<div *ngIf="isLoading$ | async" class="loader-wrapper">
  <div class="spinner"></div>
</div>
